import axios from "axios";
import { z } from "zod";
import { customerApiUrl } from "api-url";
import { BaseErrorResponse } from "api/responses";
import { createQueryRequestHook } from "shared/hooks/createQueryRequestHook";
import { transformTopExceededCapacity } from "../utils/chart.utils";

const locationSchema = z.object({
  id: z.number(),
  name: z.string(),
  code: z.string(),
  ladName: z.nullable(z.string()),
});

const locationAggregationItemSchema = z.object({
  location: locationSchema,
  vinCount: z.number(),
  capacity: z.number(),
  overage: z.number(),
});

const locationAggregationSchema = z.array(locationAggregationItemSchema);

const ResponseSchema = z.object({
  locationAggregation: locationAggregationSchema,
});

type ChartResponse = z.infer<typeof ResponseSchema>;

const useTopExceededCapacityQuery = () => {
  return createQueryRequestHook<ChartResponse, BaseErrorResponse>({
    queryKey: ["exceededCapacity"],
    queryFn: async () => {
      const url = customerApiUrl(
        `/entity-inventory/organization/metrics/exceeded-capacity`,
      );
      const response = await axios.get(url);
      return response.data;
    },
    initialData: {
      locationAggregation: [],
    },
    refetchOnWindowFocus: false,
    retry: false,
  })();
};

export const useTopExceededCapacityHook = () => {
  const { data, isFetching, isError } = useTopExceededCapacityQuery();
  let transformedData = transformTopExceededCapacity(data);

  return { listOfLocations: transformedData, isFetching, isError };
};
